export default __webpack_public_path__ + "static/media/work-3left-1.e52edd99.png";